/* Copyright 2025 Supovia LLC */

'use client'

/* Copyright 2025 Supovia LLC */
import getDocuments from '@supovia/client/getDocuments.js'
import { useQuery } from '@tanstack/react-query'

export default function useDocuments(parameters, options) {
  return useQuery({
    queryKey: ['documents', { ...parameters }],
    queryFn: () => getDocuments(parameters),
    ...options,
  })
}
